export default __webpack_public_path__ + "static/media/arrow-small-left.53382ff9.svg";